import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import NotFoundPage from 'pages/public/NotFoundPage';

import MemFeeWaiverLists from './MemFeeWaiverLists';
import MemFeeWaiverShow from './MemFeeWaiverShow';

const MemFeeWaiver = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="list" replace />} />
      <Route path="list" element={<MemFeeWaiverLists />} />
      <Route path="show/:id" element={<MemFeeWaiverShow />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default MemFeeWaiver;
